<template>
  <div class="container">
    <div class="content py-4">
      <h3 class="py-5">
        <div v-if="isSigned == 'true'" class="py-1">
          本合約已經簽約完成，請查閱簽約副本。
          <br>
          <br>
          This contract has been signed. Please review the signed copy.
        </div>
        <div v-if="checksumIsValid == 'false'" class="py-1">
          查無相關資訊，請聯繫合約發送人。
          <br>
          <br>
          No relevant information found. Please contact the contract issuer.
        </div>
        <div v-if="isLastest == 'false'" class="py-1">
          本合約版本已經無效，請查閱最新版本。
          <br>
          <br>
          This version of the contract is no longer valid. Please review the latest version of the contract.
        </div>
      </h3>
    </div>
	</div>
</template>

<script>

export default {
  name: 'resultView',
  props: {
    isSigned: {
      type: String
    },
    checksumIsValid: {
      type: String
    },
    isLastest: {
      type: String
    }
  },
  computed: {
    // 解析查询参数
    // isSigned() {
    //   return this.$route.query.isSigned || '';
    // }
  }



};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-check{
  font-size: 20px;
  display: inline-block;
  margin-bottom: 16px;
}
#signature{
  width: 100%;

  border: solid 3px #9fa9b8f1;
  border-radius: 5px;
  background: rgba(240, 248, 255, 0.916)
  /* background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box; */
}
.content{
	/* background-color: #def0f3; */
}
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
